import {
	type Section,
	SERVICE_ACCESS_SERVICES_TEMPLATES,
	type ServiceAccessObject,
	type ServiceAccessTemplateCode,
} from '@ekhodealer/ekho-common';

/**
 * Combines sections from SERVICE_ACCESS_SERVICES_TEMPLATES with direct sections
 * from serviceAccess to create a complete list of valid sections.
 *
 * @param serviceAccess - The serviceAccess object from the services provider
 * @returns A combined array of all valid sections (required + optional from both sources)
 */
export function getCombinedServiceSections(
	serviceAccess: ServiceAccessObject | undefined,
): Section[] {
	if (!serviceAccess) {
		return [];
	}

	const {
		required: directRequired = [],
		optional: directOptional = [],
		template,
	} = serviceAccess;

	// Get sections from template if it exists
	let templateRequired: Section[] = [];
	let templateOptional: Section[] = [];

	if (template) {
		const templateConfig =
			SERVICE_ACCESS_SERVICES_TEMPLATES[template as ServiceAccessTemplateCode];
		if (templateConfig) {
			templateRequired = templateConfig.required;
			templateOptional = templateConfig.optional;
		}
	}

	// Combine all sections (deduplicate)
	const allSections = new Set<Section>([
		...templateRequired,
		...templateOptional,
		...directRequired,
		...directOptional,
	]);

	return Array.from(allSections);
}
